<template>
    <v-app id="keep">

        <LoadingComponent :isLoading='$store.getters.loadingModal'/>
        <BookInfoModal :dialog="$store.getters.checkDialog"/>
        <MessageComponent v-if="$store.getters.messageModal"/>
        <ErrorMessageComponent v-if="$store.getters.errorMessageModal"/>



        <v-navigation-drawer
                app
                clipped
                fixed
                v-model="drawer">
            <br/>
            <v-list dense>
                <v-list-tile :class="item.link === navigationPath ? 'default-class elevation-6 pa-1' : 'pa-1'"
                             :key="j"
                             @click="linkToOtherPage(item)"
                             ripple v-for="(item, j) in items">
                    <v-layout row>
                        <v-list-tile-action>
                            <v-icon>{{item.icon}}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{item.label}}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-layout>
                </v-list-tile>
            </v-list>

            <v-divider class="mt-3"></v-divider>

            <v-card class="elevation-3 ma-3" v-if="loadingPage === true">
                <v-card-title><h5>Έχετε παραλάβει συνολικά {{this.$store.getters.counterDelivered + this.$store.getters.login.courseCountBeforeEudoxos}} συγγράμματα:</h5></v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                    <v-list-tile>
                        <v-list-tile-content>Παράτυπες επιλογές συγγραμμάτων</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{this.$store.getters.totalWronglyDeliveredBooks}}</v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>Έχουν επιστραφεί σε Βιβλιοθήκες</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{this.$store.getters.counterReturnedToLibrary}}</v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>Έχουν παραδοθεί σε Φοιτητές</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{this.$store.getters.counterPassedToStudent}}</v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>Διαθέσιμα για ανταλλαγή</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{this.$store.getters.counterExchangeable}}</v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile>
                        <v-list-tile-content>Πιστωτικές Μονάδες</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{$store.getters.login.exchangeCredits}}</v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-card>
            <v-divider class="mt-3"></v-divider>

            <v-card class="elevation-3 ma-3" v-if="loadingPage === true">
                <v-card-text>
                    <h5>Μπορείτε να κατεβάσετε την mobile εφαρμογή Φοιτητών για android και iOS συσκευές</h5>
                    <v-layout row wrap justify-space-around class=" mt-1">
                        <v-flex xl5 lg5 md5>
                            <a href="https://play.google.com/store/apps/details?id=io.student.eudoxus&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" target="_blank">
                                <v-img :src="require('./assets/playstore.png')" height="30px" contain alt="Κατέβασμα εφαρμογής από το Google Play Store"></v-img>
                            </a>
                            <v-img class="mt-2" :src="require('./assets/playstore_qr.png')" height="80px" contain alt=""></v-img>
                        </v-flex>

                        <v-flex xl5 lg5 md5>
                            <a href="https://apps.apple.com/gr/app/%CE%B5%CF%8D%CE%B4%CE%BF%CE%BE%CE%BF%CF%82/id6471078435" target="_blank">
                                <v-img :src="require('./assets/appstore.png')" height="30px" contain alt="Κατέβασμα εφαρμογής από το App Store"></v-img>
                            </a>
                            <v-img class="mt-2" :src="require('./assets/appstore_qr.png')" height="80px" contain alt=""></v-img>
                        </v-flex>
                    </v-layout>


                </v-card-text>
            </v-card>

        </v-navigation-drawer>
        <v-toolbar app clipped-left color="primary" dark>
            <v-toolbar-side-icon @click.native="drawer = !drawer"></v-toolbar-side-icon>
            <v-img :src="require('./assets/EUDOXUS_NEW_LOGO.png')" style=" max-height:170px; max-width:200px" contain alt=""></v-img>
            <v-spacer></v-spacer>
            <!--<v-btn @click="logout" class="secondary">Αποσύνδεση</v-btn>-->

            <v-menu
                    offset-y>
                <v-btn slot="activator"  class="secondary">{{$store.getters.login.firstname }} {{$store.getters.login.lastname}}
                <v-icon>keyboard_arrow_down</v-icon>
                </v-btn>
                <v-list>
                    <v-list-tile @click="logout">
                        <v-list-tile-title>
                            <v-icon>exit_to_app</v-icon> Αποσύνδεση</v-list-tile-title>
                    </v-list-tile>
                </v-list>


            </v-menu>

        </v-toolbar>

        <v-content>
            <v-layout align-space-between column fill-height justify-space-between>
                <!--Add v-alert message (COVID-19) for all Components -->
                <!--<v-alert :value="true" class="rounded-alert mx-3 py-2 mb-0" outline type="error">-->
                    <!--<u>Η παραλαβή των συγγραμμάτων από τα Σημεία Διανομής θα είναι δυνατή μετά την λήξη των μέτρων αντιμετώπισης για τη διασπορά του κορωνοϊού COVID-19.</u>-->
                    <!--Έχετε τη δυνατότητα να κάνετε λήψη του πρόσθετου διδακτικού υλικού σε ψηφιακή μορφή,-->
                    <!--εφόσον προσφέρεται σε κάποιο μάθημα για το οποίο επιλέξατε σύγγραμμα.-->
                    <!--<a href="https://eudoxus.gr/files/prostheto_didaktiko_uliko.pdf" target="_blank" class="red&#45;&#45;text">Οδηγίες θα βρείτε εδώ</a>-->
                <!--</v-alert>-->
                <!---->
                <router-view v-if="loadingPage === true"></router-view>
                <footer-component></footer-component>
            </v-layout>
        </v-content>

    </v-app>
</template>

<script>
    import FooterComponent from './components/FooterComponent'
    import LoadingComponent from './components/ExtraComponents/LoadingComponent'
    import {mapActions, mapGetters, mapState} from 'vuex';
    import requests from './requests.js'
    import BookInfoModal from './components/ExtraComponents/BookInfoModal'
    import MessageComponent from "./components/ExtraComponents/MessageComponent";
    import ErrorMessageComponent from "./components/ExtraComponents/ErrorMessageComponent";
    import InitializationComponent from "./components/MainDirectory/InitializationComponent";
    import util from "./utilities"

    export default {
        name: "App",
        components: {
            InitializationComponent,
            ErrorMessageComponent,
            MessageComponent,
            BookInfoModal,
            LoadingComponent,
            FooterComponent,
        },
        data: () => ({
            util,
            navigationPath: '/',
            counterDelivered: 0,
            counterReturnedToLibrary: 0,
            counterExchangable: 0,
            counterPassedToStudent: 0,
            getResponse: null,
            drawer: null,
            loadingModal: true,
            loadingPage: false,
            items: [
                {id: 0, icon: 'home', label: 'Αρχική Σελίδα', link: '/'},
                {id: 1, icon: 'receipt', label: 'Δηλώσεις Συγγραμμάτων', link: '/statements'},
                {id: 2, icon: 'compare_arrows', label: 'Ανταλλαγή Συγγραμμάτων', link: '/bookExchange'},
                {id: 3, icon: 'mdi-account-switch', label: 'Επικοινωνία με Γρ. Αρωγής', link: '/tickets'},
                {id: 4, icon: 'question_answer', label: 'Συχνές Ερωτήσεις', link: '/faq'},
                // {id: 3, icon: 'contact_support', label: 'Επικοινωνία', link: '/contactUs'}
            ]
        }),
        props: {
            source: String
        },
        computed: {
            ...mapGetters({
                fullName: 'studentFullName'
            }),

            ...mapState([
                'eudoxusTitle'
            ]),
            credits: function () {
                if(this.$store.getters.avaliableCredit != ''){
                    return this.$store.getters.avaliableCredit
                }
                else {
                    return this.$store.getters.login.exchangeCredits
                }
            }
        },
        methods: {
            ...mapActions({
                changeName: 'setFullName'
            }),

            // route to another component
            linkToOtherPage(item) {
                this.navigationPath = item.link;
                this.$router.push({path: item.link});
            },

            //http://127.0.0.1:9080/Shibboleth.sso/Logout
            logout() {
                var name = '_kps_a';
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                window.location.replace("/Shibboleth.sso/Logout");
                // requests.logout(this.openNewWindow);
            },
            listBooks() {
                let books = this.$store.getters.listForExchange;
                this.$store.commit('setCounterDelivered', books.length);
                for (let i = 0; i < books.length; i++) {
                    if (books[i].status.status == "DELIVERED") {
                        // this.counterDelivered++;
                        if (books[i].type == "Published" && !books[i].exchangable) {
                            if (books[i].finalizedByPublisher){
                            //
                            }
                            else {
                            //
                            }

                        } else if (books[i].type == "Published" &&
                            books[i].exchangable && books[i].exchangeDestinationId == null) {
                            this.counterExchangable++
                        } else if (books[i].type == "Published" &&
                            books[i].exchangable && books[i].exchangeDestinationId != null) {
                            this.counterExchangable++
                        } else if (books[i].type == "ePublished") {

                        }
                    } else if (books[i].status.status == "IN_LIBRARY") {
                        this.counterReturnedToLibrary++;
                    } else if (books[i].status.status == "EXCHANGED") {
                        this.counterPassedToStudent++;
                    }

                }
            },
            loginCallbackSuccessProfile(response1) {
                this.$store.commit('setLogin', response1.data);
                if (response1.data != null) {
                    this.$store.commit('setLoadingModal', false);
                    this.loadingModal = false;
                    this.loadingPage = true;
                    this.checkPersonalMailAndMobile();
                }

            },
            loginCallbackSuccessBooks(response) {
                if (response.data != null) {
                    this.$store.commit('setlistForExchange', response.data);
                    util.setCounterExchangeBooks();
                    // this.listBooks();
                }
            },
            loginCallBackSuccessStatement(response) {
                if (response.data.length > 0) {
                    this.$store.commit('setStatement', response.data);
                    this.createTooltipBook(response.data);
                }
            },
            loginCallBackSuccessCourier(response) {
                this.$store.commit('setCourier', response);
                this.$store.commit('setFinalDeclarationflag', true);
            },
            loginCallBackSuccessActive(response) {
                if (response.bookGroups.length < 1) {
                    this.$store.commit('setActiveDeclaration', true);
                    this.$store.commit('setNewStatementAllow', true);
                }
                this.$store.commit('setActive', response);
                if(response.hasOwnProperty("courrierId")){
                    let urlEncode = encodeURI(response.courrierId);
                    requests.courier(urlEncode, this.loginCallBackSuccessCourier);
                }
            },
            initLoading() {
                this.$store.commit('setLoadingModal', true)
            },
            onRequestErrors(response) {
                this.$store.commit('setLoadingModal', false);
                alert(response);
            },
            callBackSuccessExchangeBooks(response) {
                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setListOfExchangeBooks', response);
                this.$router.push({path: '/bookExchange'});
            },
            createTooltipBook(statement) {
                var tooltipBook = {};
                var courseCodeHashMap = {};

                for(let i=0; i<statement.length; i++){
                    for(let z=0; z<statement[i].bookGroups.length; z++){

                        let book = {};

                        if (statement[i].bookGroups[z].books.length > 0) {
                            if(statement[i].bookGroups[z].books[0].book.hasOwnProperty("status") && !tooltipBook.hasOwnProperty(statement[i].bookGroups[z].books[0].book.id)) {
                                if(statement[i].bookGroups[z].books[0].book.status.status != "INSERTED") {

                                    book = {
                                        status: {
                                            status: statement[i].bookGroups[z].books[0].book.status.status
                                        } ,
                                        delivered: statement[i].bookGroups[z].books[0].book.delivered,
                                        wronglyDelivered: statement[i].bookGroups[z].books[0].book.wronglyDelivered,
                                        borrowed: statement[i].borrowed
                                    };

                                    tooltipBook[statement[i].bookGroups[z].books[0].book.id] = {
                                        book: book,
                                        date: statement[i].bookGroups[z].books[0].book.status.statusDate,
                                        period: statement[i].period,
                                        books: {
                                            course: {
                                                year: statement[i].year
                                            }
                                        }
                                    };
                                }
                                if (!statement[i].dataEntryAllowed) {
                                    if(statement[i].bookGroups[z].books[0].book.status.status != "EXPIRED" &&
                                        statement[i].bookGroups[z].books[0].book.status.status != "IN_LIBRARY" &&
                                        statement[i].bookGroups[z].books[0].book.status.status != "RETURNED" &&
                                        statement[i].bookGroups[z].books[0].book.status.status != "EXCHANGED" &&
                                        statement[i].bookGroups[z].books[0].book.status.status != "INSERTED" &&
                                        statement[i].bookGroups[z].books[0].book.statementBookGroupType != "CREDIT") {


                                        courseCodeHashMap[statement[i].bookGroups[z].course.code] = {
                                            title: statement[i].bookGroups[z].course.title
                                        }
                                    }
                                }
                            }
                        }

                    }
                }
                this.$store.commit('setTooltipBookId', tooltipBook);
                this.$store.commit('setCourseCodeHashMap', courseCodeHashMap);
            },
            checkPersonalMailAndMobile(){

                var login = this.$store.getters.login;
                // if (!login.hasOwnProperty("courseCountBeforeEudoxos")) {
                //     login.courseCountBeforeEudoxos = 0;
                //     this.$store.commit('setLogin', login);
                // }

                if(!login.hasOwnProperty("personalEmail") || !login.hasOwnProperty("mobile") || !login.hasOwnProperty("currentSemester")){
                    this.$store.commit('setInitializationFlag', true);
                }
                else if(login.personalEmail == '' || login.mobile == '' || login.currentSemester == ''){
                    this.$store.commit('setInitializationFlag', true);
                }
            }
        },
        beforeMount: async function () {
            // this.requestLogin();
        },
        created() {
            requests.login(this.loadingModal, this.loadingPage, this.loginCallbackSuccessProfile, this.loginCallbackSuccessBooks);
            requests.active(this.loginCallBackSuccessActive);
            requests.statement(this.loginCallBackSuccessStatement);
            this.initLoading();
            if (window.performance) {
                // console.info("window.performance works fine on this browser");
            }
            if (performance.navigation.type == 1) {
                this.$router.push({path: '/'})
            } else {
                // console.info( "This page is not reloaded");
            }
        }
    }
</script>

<style lang="stylus">
    #keep
        .v-navigation-drawer__border
            display: none

    * {
        text-transform: none !important;
    }

    .rounded-alert {
        border-radius: 15px;
    }

    .rounded-alert-chip {
        border-radius: 20px;
    }

    .pointerCursor {
        cursor: pointer !important;
    }
</style>
